module.exports = __webpack_public_path__ + "img/hc_pro_four_6.0a888f7d.jpg";